import React, { useCallback, useState } from 'react';
import TextField from '@atlaskit/textfield';
import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import { FORMAT_STYLE_DECIMAL } from '../../types.tsx';
import { formatNumberField } from '../../index.tsx';
import type { Props } from './types.tsx';

export const FormattedNumberField = (props: Props) => {
	const { width = 'auto', value, formatConfig, ...rest } = props;

	const [editMode, setEditMode] = useState(false);
	const locale = useLocale();

	const formatNumber = useCallback(
		(newValue: string) => {
			// the browser should only provide valid numeric inputs, but double check to be safe
			const newNumber = Number(newValue);
			if (newValue && !Number.isNaN(newNumber)) {
				return formatNumberField(newNumber, {
					formatStyle: formatConfig.formatStyle ?? FORMAT_STYLE_DECIMAL,
					formatUnit: formatConfig.formatUnit,
					locale,
				});
			}
			// TODO: TNK-4376 - Confirm return behaviour for non-numeric inputs
			return '';
		},
		[locale, formatConfig],
	);

	return (
		<TextField
			{...rest}
			width={width}
			type={editMode ? 'number' : 'text'}
			onFocus={() => setEditMode(true)}
			onBlur={() => setEditMode(false)}
			value={editMode ? value : formatNumber(value)}
			testId="platform-utils-number.ui.formatted-number-field.text-field"
		/>
	);
};
